import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open({ params }) {
    window.dispatchEvent(new CustomEvent("completeness:open-reminder", {
      detail: { ...params, triggerElement: this.element }
    }))
  }

  openBulk({ params }) {
    const selectedIds = Array.from(
      document.querySelectorAll("input[name='company_ids[]']:checked")
    ).map(el => parseInt(el.value, 10))

    window.dispatchEvent(new CustomEvent("completeness:open-bulk-reminder", {
      detail: { ...params, selectedIds }
    }))
  }
}
